export const InitializeIndexedDBWorker = () => {
  const worker = new Worker(new URL("/IndexedDBWorker.js", import.meta.url), {
    type: "module",
    credentials: "same-origin",
  });
  const IndexedDBPostMessage = (
    action,
    body = null,
    successEvent = () => {},
    errorEvent = () => {},
  ) => {
    worker.onmessage = (results) => {
      if (successEvent) {
        successEvent(results.data);
      }
    };
    worker.onerror = (results) => {
      if (errorEvent) {
        errorEvent(results);
      }
    };
    worker.onmessageerror = (results) => {
      if (errorEvent) {
        errorEvent(results);
      }
    };
    worker.postMessage({
      action,
      body,
    });
  };
  return IndexedDBPostMessage;
};
